export default __webpack_public_path__ + "static/media/decorativa.1ec8a5c6.png";